import isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';
import type { UserOption } from '@atlassian/jira-base-user-picker/src/types.tsx';
import type { TransformedUser } from '../../../services/get-list-view-issues/types.tsx';
import type { User } from './types.tsx';

const sortUserOptions = (options: UserOption[]) => sortBy(options, ['id']);

export const isUserOptionsEqual = (a: UserOption[] | null, b: UserOption[] | null) =>
	isEqual(a, b) || isEqual(a && sortUserOptions(a), b && sortUserOptions(b));

export const transformToUserOption = (userData: User | TransformedUser): UserOption | null => {
	if (!userData) {
		return null;
	}

	return {
		avatarUrl: 'picture' in userData ? userData.picture : userData.avatarUrl,
		id: userData.accountId,
		name: userData.name ?? '',
	};
};
